import { matchesRecentProfessional } from '~/domain/RecentProfessionals/recentProfessionalsHelpers';

export interface IInviteCategoryCounts {
  total: number;
  favorite: number;
  workedWith: number;
  newToYou: number;
}

/**
 * Buckets selected professional ids into favorite / worked-with / new-to-you for
 * the `invite_sent` analytics event. Anything not found in the favorite or recent
 * lists is treated as "new to you". Shared by every invite entry point so the
 * category breakdown stays consistent (and the recent-id match stays correct).
 */
export function countInviteCategories(
  ids: string[],
  favorites: ReadonlyArray<{ id?: string }> = [],
  recent: ReadonlyArray<{ id?: string; professional?: { id?: string } | null }> = [],
): IInviteCategoryCounts {
  const favorite = ids.filter((id) => favorites.some((p) => p?.id === id)).length;
  const workedWith = ids.filter((id) =>
    recent.some((p) => matchesRecentProfessional(p, id)),
  ).length;

  return {
    total: ids.length,
    favorite,
    workedWith,
    newToYou: Math.max(0, ids.length - favorite - workedWith),
  };
}
